import React, { useEffect, useState, useCallback, useMemo } from "react";
import RequiredLabel from "../CustomCommons/RequiredLabel";
import { Form, InputGroup } from "react-bootstrap";
import { handleInputs } from "../../utils/HandleInputs";
import { BASE_URL } from "../Const/Url";
import axios from "axios";
import Select from "react-select";
import eye from "../../assets/Icon/eye.svg";
import swal from "sweetalert";
import { showToast } from "../../utils/ToastHelper";
import * as path from "./../Routes/RoutePaths";
import { useHistory, useParams } from "react-router-dom";
import Loader from "../CustomCommons/Loader";
import { handleSelectAll } from "../Const/Status";
import SelectOpenWithPagginationDynamic from "../Const/SelectOpenWithPagginationDynamic";
import CustomModal from "../CustomCommons/CustomModal";
import ConflictPD from "./ConflictPD";

const discountForOptions = [
  { label: "Admin", value: "Admin" },
  { label: "Website", value: "Website" },
  { label: "Outlet", value: "Outlet" },
];

const offerTypeOptions = [{ value: 0, label: "General Offer" }];

const offerBasedOptions = [
  { value: 0, label: "CATEGORY" },
  { value: 1, label: "PRODUCT" },
];

const categoryForOptions = [
  { value: 3, label: "****None****" },
  { value: 0, label: "Home Decor" },
  { value: 1, label: "In style" },
  { value: 2, label: "Both" },
];

const discountTypeOptions = [
  { value: 0, label: "Flat" },
  { value: 1, label: "Percentage" },
];

const quantityAmountOptions = [
  { value: 0, label: "---Select---" },
  { value: 1, label: "Minimum Quantity For Offer" },
  { value: 2, label: "Minimum Purchace Amount" },
];

const EditOffer = () => {
  const { id } = useParams();
  const history = useHistory();

  // State for form data
  const [formData, setFormData] = useState({
    name: "",
    discount_value: "",
    expiry_date: "",
    start_date: "",
    description: "",
  });

  // Component states
  const [fileName, setFileName] = useState("");
  const [isActive, setIsActive] = useState(true);
  const [isWebsite, setIsWebsite] = useState(true);
  const [isOutlet, setIsOutlet] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [selectedOutlet, setSelectedOutlet] = useState(null);
  const [outletList, setOutletList] = useState([]);
  const [excludeCategory, setExcludeCategory] = useState([]);
  const [excludeProduct, setExcludeProduct] = useState([]);
  const [mainOfferType, setMainOfferType] = useState(0);
  const [quantityOrAmount, setQuantityOrAmount] = useState(0);
  const [quantityForCombo, setQuantityForCombo] = useState(0);
  const [amountForCombo, setAmountForCombo] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [conflictedPd, setConflictedPd] = useState([]);
  const [imageUrl, setImageUrl] = useState("");
  const [thumbFile, setThumbFile] = useState(null);
  const [thumbId, setThumbId] = useState(null);
  const [selectProduct, setSelectProduct] = useState([]);
  const [searchProductLabel, setSearchProductLabel] = useState("");
  const [invoice_discount_type, setInvoiceDiscountType] = useState(0);
  const [invoiceFor, setInvoiceFor] = useState(0);
  const [invoice_CatChoice, setInvoiceCatChoice] = useState(3);
  const [inputQuery, setInputQuery] = useState("");
  const [inputQueryExPd, setInputQueryExPd] = useState("");
  const [inputQueryCategory, setInputQueryCategory] = useState("");
  const [productList, setProductList] = useState([]);
  const [productListExPd, setProductListExPd] = useState([]);
  const [categoryList, setCategoryList] = useState([]);
  const [selectCategory, setSelectCategory] = useState([]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [offerProductBased, setOfferProductBased] = useState(0);

  // Memoized values
  const discountForLabels = useMemo(() => {
    const labels = [];
    if (isAdmin) labels.push({ label: "Admin", value: "Admin" });
    if (isOutlet) labels.push({ label: "Outlet", value: "Outlet" });
    if (isWebsite) labels.push({ label: "Website", value: "Website" });
    return labels;
  }, [isAdmin, isOutlet, isWebsite]);

  // API calls
  const fetchOfferDetails = useCallback(async () => {
    try {
      const url = `${BASE_URL}api/v1/promotions/admin/offer/${id}/`;
      const response = await axios.get(url);
      const data = response.data.data;

      setFormData({
        name: data?.name,
        discount_value: data?.discount_value,
        expiry_date: "",
        start_date: "",
        description: "",
      });

      setOfferProductBased(data?.category_or_product_based);
      setInvoiceDiscountType(data?.discount_type);
      setInvoiceFor(data?.discount_for);
      setInvoiceCatChoice(data?.main_category);
      setStartDate(data?.start_date.split("T")[0]);
      setEndDate(data?.expiry_date.split("T")[0]);
      setIsActive(data?.is_active);
      setThumbId(data?.banner);
      setImageUrl(data?.banner_url);
      setMainOfferType(data?.offer_combo_type);
      setQuantityOrAmount(data?.offer_based_on);
      setQuantityForCombo(data?.minimum_purchase_quantity);
      setAmountForCombo(data?.minimum_purchase_amount);

      const productDetails =
        data?.product_details?.map((item) => ({
          label: `${item.name} [[${item?.sku}]]`,
          value: item.id,
        })) || [];

      const categoryDetails =
        data?.category_details?.map((item) => ({
          label: item.name,
          value: item.id,
        })) || [];

      const excludeProductDetails =
        data?.exclude_product_details?.map((item) => ({
          label: `${item.name} [[${item?.sku}]]`,
          value: item.id,
        })) || [];

      const excludeCategoryDetails =
        data?.exclude_category_details?.map((item) => ({
          label: item.name,
          value: item.id,
        })) || [];

      const outletDetails =
        data.outlet_details?.map((item) => ({
          label: item.name,
          value: item.id,
        })) || [];

      setSelectProduct(productDetails);
      setSelectCategory(categoryDetails);
      setExcludeProduct(excludeProductDetails);
      setExcludeCategory(excludeCategoryDetails);
      setSelectedOutlet(outletDetails);
      setIsOutlet(data?.is_outlet);
      setIsAdmin(data?.is_admin);
      setIsWebsite(data?.is_website);

      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching offer details:", error);
      if (error.response?.status === 401) {
        // Handle unauthorized access
      }
      setIsLoading(false);
    }
  }, [id]);

  const fetchOutletList = useCallback(async () => {
    try {
      const url = `${BASE_URL}api/v1/sales/admin/outlet/`;
      const response = await axios.get(url);
      const options = response.data.data.results.map((item) => ({
        label: item.name,
        value: item.id,
      }));
      setOutletList(options);
    } catch (error) {
      console.error("Error fetching outlet list:", error);
    }
  }, []);

  const fetchCategoryList = useCallback(async (query) => {
    if (query?.length > 1) {
      try {
        const url = query
          ? `${BASE_URL}api/v1/inventory/inventory/category/?category_type=2&query=${query}`
          : `${BASE_URL}api/v1/inventory/inventory/category/?category_type=2`;

        const response = await axios.get(url);
        const options = response.data.data.results.map((item) => ({
          label: item.name,
          value: item.id,
        }));
        setCategoryList(options);
      } catch (error) {
        console.error("Error fetching category list:", error);
      }
    }
  }, []);

  // Effects
  useEffect(() => {
    fetchOfferDetails();
    fetchOutletList();
  }, [fetchOfferDetails, fetchOutletList]);

  useEffect(() => {
    fetchCategoryList(inputQueryCategory);
  }, [inputQueryCategory, fetchCategoryList]);

  // Handlers
  const handleFileUpload = useCallback(async (file) => {
    if (!file) return;

    const url = `${BASE_URL}api/v1/auth/documents/upload/`;
    const formData = new FormData();
    formData.append("document", file);
    formData.append("doc_type", 0);

    try {
      const response = await axios.post(url, formData);
      if (response.data.status) {
        setThumbId(response.data.data.id);
        setFileName(file.name);

        const reader = new FileReader();
        reader.onload = () => {
          if (reader.readyState === 2) {
            setImageUrl(reader.result);
          }
        };
        reader.readAsDataURL(file);

        showToast("success", "Image uploaded successfully");
      }
    } catch (error) {
      showToast(
        "error",
        error.response?.data?.errors?.document?.[0] || "Failed to upload image"
      );
    }
  }, []);

  const handleRemoveImage = useCallback(() => {
    swal({
      title: "Are you sure?",
      text: "Once removed, you will not be able to recover this file!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        setImageUrl("");
        setFileName("");
        setThumbFile(null);
        setThumbId(null);
        swal("Your file has been removed!", { icon: "success" });
      } else {
        swal("Your file is safe!");
      }
    });
  }, []);

  const handleDiscountForChange = useCallback((selectedOptions) => {
    setIsAdmin(selectedOptions.some((option) => option.label === "Admin"));
    setIsWebsite(selectedOptions.some((option) => option.label === "Website"));
    setIsOutlet(selectedOptions.some((option) => option.label === "Outlet"));
  }, []);

  const handleSubmit = useCallback(async () => {
    setIsSubmitting(true);
    const url = `${BASE_URL}api/v1/promotions/admin/offer/${id}/`;

    if (!formData.name) {
      showToast("error", "Offer name is required");
      setIsSubmitting(false);
      return;
    }

    if (
      selectCategory.length === 0 &&
      selectProduct.length === 0 &&
      invoice_CatChoice === 3
    ) {
      showToast("error", "Please add at least one product or category");
      setIsSubmitting(false);
      return;
    }

    const payload = {
      name: formData.name,
      description: formData.description,
      discount_type: invoice_discount_type,
      discount_value: formData.discount_value,
      start_date: startDate,
      expiry_date: endDate,
      is_active: isActive,
      category_or_product_based: offerProductBased,
      banner: thumbId,
      product: selectProduct.map((item) => item.value),
      category: selectCategory.map((item) => item.value),
      discount_for: 0,
      main_category: invoice_CatChoice,
      offer_combo_type: mainOfferType,
      offer_based_on: quantityOrAmount,
      minimum_purchase_quantity: quantityForCombo,
      minimum_purchase_amount: amountForCombo,
      is_outlet: isOutlet,
      is_website: isWebsite,
      is_admin: isAdmin,
      outlet: isOutlet ? selectedOutlet?.map((item) => item.value) : [],
      exclude_category: excludeCategory?.map((item) => item.value) || [],
      exclude_product: excludeProduct?.map((item) => item.value) || [],
    };

    try {
      const response = await axios.patch(url, payload);
      if (response.data.status) {
        showToast("success", "Offer updated successfully");
        history.push(path.offer);
      }
    } catch (error) {
      setIsSubmitting(false);
      const errorData = error.response?.data;

      if (errorData?.errors?.conflicting_products) {
        setConflictedPd(errorData.errors.conflicting_products);
        setIsModalOpen(true);
      } else {
        const errorMessage = errorData?.message || "An error occurred";
        showToast("error", errorMessage);
      }
    }
  }, [
    id,
    formData,
    selectCategory,
    selectProduct,
    invoice_CatChoice,
    invoice_discount_type,
    startDate,
    endDate,
    isActive,
    offerProductBased,
    thumbId,
    mainOfferType,
    quantityOrAmount,
    quantityForCombo,
    amountForCombo,
    isOutlet,
    isWebsite,
    isAdmin,
    selectedOutlet,
    excludeCategory,
    excludeProduct,
    history,
  ]);

  if (isLoading) {
    return <Loader />;
  }

  return (
    <div className="categorey-parent new-categorey-parent an">
      <div className="bg-white add-div">
        <div
          className="d-flex align-items-center"
          style={{ padding: "20px 35px", border: "0.5px solid #E0E0E0" }}
        >
          <h3 style={{ fontSize: "23px", marginTop: "6px" }}>Edit Offer </h3>
        </div>

        <div
          style={{
            padding: "20px 35px",
            borderBottom: "0.5px solid #E0E0E0",
            borderRight: "0.5px solid #E0E0E0",
            borderLeft: "0.5px solid #E0E0E0",
          }}
          className="row"
        >
          <p style={{ marginTop: "10px", color: "red" }}>
            NB: If your offer is based on Category, please select "CATEGORY"
            from the dropdown. If your offer is based on a specific Product,
            select "PRODUCT" from the dropdown and proceed to choose the
            relevant product.
          </p>

          {/* Offer Based On */}
          <div className="col-12">
            <RequiredLabel text="Offer Based ON" />
            <Form.Select
              size="lg"
              style={selectStyle}
              value={offerProductBased}
              onChange={(e) => setOfferProductBased(parseInt(e.target.value))}
            >
              {offerBasedOptions.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </Form.Select>
          </div>

          {/* Offer Name */}
          <div className="col-12 col-md-6">
            <RequiredLabel text="Offer Name" />
            <InputGroup className="mb-3" style={{ height: "47px" }}>
              <Form.Control
                style={inputStyle}
                name="name"
                value={formData.name}
                onChange={(e) => handleInputs(e, setFormData)}
              />
            </InputGroup>
          </div>

          {/* Main Offer Type */}
          <div className="col-12 col-md-6">
            <RequiredLabel text="Main Offer Type" />
            <Form.Select
              size="lg"
              style={selectStyle}
              value={mainOfferType}
              onChange={(e) => setMainOfferType(parseInt(e.target.value))}
            >
              {offerTypeOptions.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </Form.Select>
          </div>

          {/* Discount Type */}
          <div className="col-12 col-md-6">
            <RequiredLabel text="Discount Type" />
            <Form.Select
              size="lg"
              style={selectStyle}
              value={invoice_discount_type}
              onChange={(e) => setInvoiceDiscountType(parseInt(e.target.value))}
            >
              {discountTypeOptions.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </Form.Select>
          </div>

          {/* Discount Value */}
          <div className="col-12 col-md-6">
            <RequiredLabel text="Discount Value" />
            <InputGroup className="mb-3" style={{ height: "47px" }}>
              <Form.Control
                style={inputStyle}
                name="discount_value"
                value={formData.discount_value}
                onChange={(e) => handleInputs(e, setFormData)}
                type="number"
                min={0}
              />
            </InputGroup>
          </div>

          {/* Discount For */}
          <div className="col-12">
            <RequiredLabel text="Discount For" />
            <Select
              isMulti
              placeholder="---Select---"
              options={discountForOptions}
              value={discountForLabels}
              onChange={handleDiscountForChange}
            />
          </div>

          {/* Outlet Selection */}
          {isOutlet && mainOfferType === 0 && (
            <div className="col-12 my-2">
              <RequiredLabel text="Outlet" />
              <Select
                isMulti
                placeholder="---Select---"
                options={outletList}
                value={selectedOutlet}
                onChange={setSelectedOutlet}
              />
            </div>
          )}

          {/* Category For Offer */}
          <div className="col-12 col-md-6">
            <RequiredLabel text="Category For Offer" />
            <Form.Select
              size="lg"
              style={selectStyle}
              value={invoice_CatChoice}
              onChange={(e) => setInvoiceCatChoice(Number(e.target.value))}
            >
              {categoryForOptions.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </Form.Select>
          </div>

          {/* Combo Offer Fields */}
          {mainOfferType === 1 && (
            <>
              <div className="col-12 col-md-6">
                <RequiredLabel text="Select Quantity/Amount For Offer" />
                <Form.Select
                  size="lg"
                  style={selectStyle}
                  value={quantityOrAmount}
                  onChange={(e) =>
                    setQuantityOrAmount(parseInt(e.target.value))
                  }
                >
                  {quantityAmountOptions.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </Form.Select>
              </div>

              {quantityOrAmount === 1 && (
                <div className="col-12 col-md-6">
                  <RequiredLabel text="Minimum Quantity For Offer" />
                  <Form.Control
                    style={inputStyle}
                    type="number"
                    min={0}
                    value={quantityForCombo}
                    onChange={(e) => setQuantityForCombo(e.target.value)}
                  />
                </div>
              )}

              {quantityOrAmount === 2 && (
                <div className="col-12 col-md-6">
                  <RequiredLabel text="Minimum Amount For Offer" />
                  <Form.Control
                    style={inputStyle}
                    type="number"
                    min={0}
                    value={amountForCombo}
                    onChange={(e) => setAmountForCombo(e.target.value)}
                  />
                </div>
              )}
            </>
          )}

          {/* Date Fields */}
          <div className="col-12 col-md-6">
            <RequiredLabel text="Offer Start Date" />
            <Form.Control
              type="date"
              style={inputStyle}
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
            />
          </div>

          <div className="col-12 col-md-6">
            <RequiredLabel text="Offer Expiry Date" />
            <Form.Control
              type="date"
              style={inputStyle}
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
            />
          </div>

          {/* Category/Product Selection */}
          {offerProductBased === 0 && invoice_CatChoice === 3 && (
            <>
              <div className="col-12 mb-2">
                <p>Category</p>
                <Select
                  isMulti
                  value={selectCategory}
                  options={categoryList}
                  placeholder="---Select---"
                  onInputChange={setInputQueryCategory}
                  onChange={setSelectCategory}
                />
              </div>

              <div className="col-12 mb-2">
                <p>Exclude Category</p>
                <Select
                  isMulti
                  value={excludeCategory}
                  options={categoryList}
                  placeholder="---Select---"
                  onInputChange={setInputQueryCategory}
                  onChange={setExcludeCategory}
                />
              </div>
            </>
          )}

          {offerProductBased === 1 &&
            invoice_CatChoice === 3 &&
            quantityOrAmount !== 2 && (
              <div className="col-12">
                <RequiredLabel className={"mt-2"} text="Products" />
                <div className="position-relative pb-2">
                  <div className="position-absolute start-0 top-0 ms-5 ps-5">
                    <input
                      type="text"
                      className="filter-input"
                      placeholder="Filter by Search"
                      value={searchProductLabel}
                      onChange={(e) =>
                        setSearchProductLabel(e.target.value.toLowerCase())
                      }
                    />
                  </div>
                  <SelectOpenWithPagginationDynamic
                    handleMultiInputChange={setSelectProduct}
                    inputProduct={setInputQuery}
                    ProductsList={productList}
                    searchProductLabel={searchProductLabel}
                    setSearchProductLabel={setSearchProductLabel}
                    defaultValue={selectProduct}
                    setProductsList={setProductList}
                    inputQuery={inputQuery}
                    selectAll={() =>
                      handleSelectAll(productList, setSelectProduct)
                    }
                    url1={`api/v1/inventory/inventory/product_list_for_offer/?is_website=${isWebsite}&is_admin=${isAdmin}&is_outlet=${isOutlet}&limit=20`}
                    url2={`api/v1/inventory/inventory/product_list_for_offer/?query=${inputQuery}&is_admin=${isAdmin}&is_outlet=${isOutlet}&limit=20`}
                  />
                </div>
              </div>
            )}

          {/* Exclude Products */}
          {quantityOrAmount !== 2 && (
            <div className="col-12 mt-2">
              <RequiredLabel text="Exclude Products" />

              <SelectOpenWithPagginationDynamic
                handleMultiInputChange={setExcludeProduct}
                inputProduct={setInputQueryExPd}
                ProductsList={productListExPd}
                defaultValue={excludeProduct}
                setProductsList={setProductListExPd}
                inputQuery={inputQueryExPd}
                selectAll={() =>
                  handleSelectAll(productListExPd, setExcludeProduct)
                }
                url1="api/v1/inventory/inventory/products/?limit=20"
                url2={`api/v1/inventory/inventory/products/?query=${inputQueryExPd}&limit=20`}
              />
            </div>
          )}

          {/* Description */}
          <div className="col-12 mt-3">
            <p>Description</p>
            <Form.Control
              as="textarea"
              style={{ ...inputStyle, height: "100px" }}
              value={formData.description}
              onChange={(e) =>
                setFormData((prev) => ({
                  ...prev,
                  description: e.target.value,
                }))
              }
            />
          </div>

          {/* Thumbnail Upload */}
          <div className="row d-flex justify-content-between">
            <p style={{ marginTop: "10px", color: "red" }}>
              NB: Upload image in (height-523px, width-392px) for thumbnail.
            </p>

            <div className="col-12 col-md-5">
              <h5 style={{ marginTop: "30px" }}>Thumbnail image</h5>
              <p style={{ color: "#8E8E93" }}>(Select your file & uploaded)</p>

              <div
                className="w-100 browse-main d-flex align-items-center"
                style={browseStyle}
              >
                <p className="my-2 ms-2" style={{ color: "#4F4F4F" }}>
                  {fileName || "You can select new"}
                </p>

                <div className="file-up">
                  <input
                    type="file"
                    onChange={(e) => handleFileUpload(e.target.files[0])}
                    accept="image/*"
                  />
                  <p>Browse</p>
                </div>
              </div>

              {imageUrl && (
                <div className="my-2">
                  <img height={90} width={90} src={imageUrl} alt="Thumbnail" />
                  <br />
                  <button
                    onClick={handleRemoveImage}
                    className="remove-btn btn btn-small mt-1 rounded"
                    style={{ border: "1px solid gray !important" }}
                  >
                    Remove
                  </button>
                </div>
              )}
            </div>

            {/* Status Toggle */}
            <div className="col-12 col-md-5">
              <h5 style={{ marginTop: "30px" }}>Status</h5>
              <p style={{ color: "#8E8E93" }}>
                (If the Category Option is available)
              </p>

              <div className="row mr-4">
                <div
                  className="d-flex justify-content-between col-12 py-3"
                  style={statusStyle}
                >
                  <div className="d-flex w-100">
                    <div style={eyeIconStyle}>
                      <img src={eye} alt="Visibility" />
                    </div>
                    <span className="mx-3">{isActive ? "ON" : "OFF"}</span>
                  </div>

                  <div className="form-check form-switch">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      role="switch"
                      checked={isActive}
                      onChange={() => setIsActive(!isActive)}
                      style={{ width: "40px", height: "20px" }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Confirmation Modal */}
          <CustomModal
            isOpen={isModalOpen}
            onClose={() => setIsModalOpen(false)}
          >
            {conflictedPd.length > 0 && <ConflictPD products={conflictedPd} />}
          </CustomModal>

          {/* Action Buttons */}
          <div className="mt-2 mt-md-4" style={{ marginLeft: "-10px" }}>
            <button
              onClick={handleSubmit}
              className="save-btn me-2 mt-2"
              style={{
                background: isSubmitting ? "gray" : "#000",
                color: "white",
              }}
              disabled={isSubmitting}
            >
              {isSubmitting ? "Saving..." : "Save"}
            </button>

            <button
              onClick={() => history.push(path.offer)}
              className="save-btn mt-2"
              style={cancelButtonStyle}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

// Style constants
const selectStyle = {
  backgroundColor: "#FAFAFA",
  fontSize: "16px",
  height: "47px",
  borderRadius: "8px",
  color: "#828282",
};

const inputStyle = {
  backgroundColor: "#FAFAFA",
};

const browseStyle = {
  height: "55px",
  border: "1px solid #E0E0E0",
  borderRadius: "7px",
  overflowX: "hidden",
};

const statusStyle = {
  backgroundColor: "#F2F2F7",
  borderRadius: "8px",
};

const eyeIconStyle = {
  backgroundColor: "#212121",
  width: "32px",
  height: "32px",
  borderRadius: "3px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};

const cancelButtonStyle = {
  border: ".4px solid #E0E0E0 !important",
};

export default EditOffer;
